export const useDefaultData = ({helpers}) => {

    const {getCurrentDate} = helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormLease = {
        idcontrato: 0,
        idcasa: '',
        idcliente: '',
        contrato_fecha: '',
        contrato_dia_pago: '',
        contrato_plazo_meses: '',
        contrato_costo_alquiler: '',
        contrato_total_alquiler: '',
        contrato_observaciones: '',
        
        // Info aprobacion (solo lectura)
        aprobacion_check: '',
        aprobacion_fecha: '',
        aprobacion_observaciones: ''

    }

    const defaultFormFiles = {
        idcontrato: '',
        files :[],
        acceptedFiles: [],
        fileRejections: []
    }


    const defaultFormDeposit = {
        iddeposit: '',
        idcaja: '',
        idbanco: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        deposito_dolares: '',
        deposito_fecha: getCurrentDate(),
        deposito_moneda: '',
        deposito_monto: '',
        deposito_observaciones: '',
        deposito_quetzales: '',
        deposito_tipo_cambio: 7.8,
        movimiento_tipo: '',
        aprobacion_check: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];

    const optionsAprobacionCheck = [
        { value: 'Aprobado', label: 'Aprobado' },
        { value: 'Pendiente Contrato', label: 'Pendiente Contrato' },
        { value: 'Rechazado', label: 'Rechazado' },
        { value: 'Pendiente Aprobacion', label: 'Pendiente Aprobacion' },
    ];



    return Object.freeze({
        defaultDataModal,
        defaultFormDeposit,
        defaultFormFiles,
        defaultFormLease,
        optionsAprobacionCheck,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
    })
}